// @flow
import React, { type Node } from 'react';
import { Button, Modal } from 'angieslist-react-components';
import { stylesColors } from 'angieslist-styles';
import CircularIcon from '../CircularIcon';

type Props = {
  iconClassName: string,
  headerText: string,
  subHeaderText?: string,
  handleClose?: () => void,
  modalBody: Node,
  showModal: bool
};

const styles = {
  modalBody: {
    padding: '33px 48px 0 48px',
  },
  modalContent: {
    margin: '0 16px',
  },
  modalFooter: {
    width: '80%',
    margin: 'auto',
  },
};

const CardModal = ({
  iconClassName,
  headerText,
  subHeaderText = '',
  modalBody,
  showModal,
  handleClose = () => {},
}: Props): Node => (
  <Modal show={showModal} onHide={handleClose} >
    <Modal.Header >
      <Modal.Title />
    </Modal.Header>
    <Modal.Body>
      <div className="modal-body" style={styles.modalBody}>
        <div className="text-center">
          <CircularIcon iconClassName={iconClassName} size={52} />
          <h3>{headerText}</h3>
          <If condition={subHeaderText}>
            <h4 style={{ color: stylesColors.textBodyLight }}>{subHeaderText}</h4>
          </If>
        </div>
        <hr />
        <div style={styles.modalContent}>
          {modalBody}
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <div className="modal-footer" style={styles.modalFooter}>
        <Button id="card-modal--close-button" onClick={handleClose} bsStyle="primary-office" bsSize="small" flat block>Close</Button>
      </div>
    </Modal.Footer>
  </Modal>
);

CardModal.defaultProps = {
  subHeaderText: '',
  handleClose: () => {},
};

export default CardModal;



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/Dashboard/Card/CardModal.js